
import { motion } from "framer-motion"
import { FiSearch, FiCheckCircle, FiTrendingUp, FiXCircle } from "react-icons/fi"
const ControlsSectionComponent = ({
    darkMode,
    setSelectedStatus,
    selectedStatus,
    searchQuery,
    setSearchQuery,
    cardBorder,
    buttonBg,
    buttonHoverBg,
    inputBg,
    inputBorder
}) => {
  return (
    <>
      <motion.div
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.2 }}
        className="mb-8"
      >
        <div className={`${darkMode ? "bg-gray-800/30" : "bg-white/50"} ${cardBorder} backdrop-blur-sm p-4 rounded-xl border`}>
          <div className="flex flex-col md:flex-row gap-4 items-center justify-between">
            <div className="flex flex-wrap gap-2">
              <button
                onClick={() => setSelectedStatus("all")}
                className={`px-4 py-2 rounded-lg transition-all duration-300 ${selectedStatus === "all" 
                  ? darkMode ? 'bg-blue-500 text-white' : 'bg-blue-600 text-white' 
                  : `${buttonBg} ${buttonHoverBg}`}`}
              >
                All Products
              </button>
              <button
                onClick={() => setSelectedStatus("STABLE")}
                className={`px-4 py-2 rounded-lg transition-all duration-300 flex items-center gap-2 ${selectedStatus === "STABLE" 
                  ? darkMode ? 'bg-green-500/20 text-green-400 border border-green-500' : 'bg-green-100 text-green-800 border border-green-300'
                  : `${buttonBg} ${buttonHoverBg}`}`}
              >
                <FiCheckCircle /> Stable
              </button>
              <button
                onClick={() => setSelectedStatus("OPPORTUNITY")}
                className={`px-4 py-2 rounded-lg transition-all duration-300 flex items-center gap-2 ${selectedStatus === "OPPORTUNITY" 
                  ? darkMode ? 'bg-blue-500/20 text-blue-400 border border-blue-500' : 'bg-blue-100 text-blue-800 border border-blue-300'
                  : `${buttonBg} ${buttonHoverBg}`}`}
              >
                <FiTrendingUp /> Opportunity
              </button>
              <button
                onClick={() => setSelectedStatus("CRITICAL")}
                className={`px-4 py-2 rounded-lg transition-all duration-300 flex items-center gap-2 ${selectedStatus === "CRITICAL" 
                  ? darkMode ? 'bg-red-500/20 text-red-400 border border-red-500' : 'bg-red-100 text-red-800 border border-red-300'
                  : `${buttonBg} ${buttonHoverBg}`}`}
              >
                <FiXCircle /> Critical
              </button>
            </div>
            
            <div className="relative">
              <FiSearch className={`absolute left-3 top-1/2 transform -translate-y-1/2 ${darkMode ? "text-gray-400" : "text-gray-500"}`} />
              <input
                type="text"
                placeholder="Search products..."
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                className={`pl-10 pr-4 py-2 ${inputBg} border ${inputBorder} rounded-lg focus:outline-none focus:ring-2 ${darkMode ? "focus:ring-blue-500" : "focus:ring-blue-600"} focus:border-transparent w-full md:w-64`}
              />
            </div>
          </div>
        </div>
      </motion.div>
    </>
  )
}

export default ControlsSectionComponent